import script from "./TheDocument.vue?vue&type=script&setup=true&lang=js"
export * from "./TheDocument.vue?vue&type=script&setup=true&lang=js"

import "./TheDocument.vue?vue&type=style&index=0&id=1db2efc3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1db2efc3"]])

export default __exports__